module.exports = __webpack_public_path__ + "assets/activity.5b280675.svg";